import type {
  GoodsRenderModel,
  GoodsCoreModel,
  GoodsFirstPageRenderingModel,
  IScreensLogging,
  PrimaryCardModel,
} from '../../../../api/types';

export type GoodsCardEntity = {
  type?: 'GOODS_CARD';
  item: GoodsCoreModel;
  logging: IScreensLogging;
  render?: GoodsRenderModel;
};

export type PrimaryCardEntity = {
  type: 'PRIMARY_CARD';
  item: PrimaryCardModel;
  logging: IScreensLogging;
};

// 비디오 상품 카드 — 비디오 + 상품 썸네일/가격/마켓/상품명
export type VideoGoodsCardEntity = {
  type: 'VIDEO_GOODS_CARD';
  item: VideoGoodsItemModel;
  logging: IScreensLogging;
};

// 풀 비디오 상품 카드 — 비디오만 (상품 정보 없음)
export type FullVideoGoodsCardEntity = {
  type: 'FULL_VIDEO_GOODS_CARD';
  item: VideoGoodsItemModel;
  logging: IScreensLogging;
};

// 서버에서 내려오는 비디오 상품 아이템 모델
export interface VideoGoodsItemModel {
  sno: number;
  video: {
    url: string;
    ratio: number;
    preview_image_url: string;
  };
  like?: {
    is_liked: boolean;
    list_id?: string;
    list_params?: string;
  };
  image?: {
    url: string;
    ratio: number;
    use_animation: boolean;
  };
  image_badge_list?: {
    image_url: string;
    image_width?: number;
    image_height?: number;
  }[];
  price: number;
  name?: string;
  discount_rate?: number;
  market_name?: string;
  market_type?: string;
  market_sno?: number;
  category_name?: string;
  ad?: {
    campaign_id: string;
    goods_sno: number;
    list_id: string;
    parameters: string;
  } | null;
  first_page_rendering?: GoodsFirstPageRenderingModel | null;
}

export const isGoodsCard = (entity: CardEntity): entity is GoodsCardEntity => {
  return entity.type === 'GOODS_CARD' || entity.type == null;
};

export const isPrimaryCard = (entity: CardEntity): entity is PrimaryCardEntity => {
  return entity.type === 'PRIMARY_CARD';
};

export const isVideoGoodsCard = (entity: CardEntity): entity is VideoGoodsCardEntity => {
  return entity.type === 'VIDEO_GOODS_CARD';
};

export const isFullVideoGoodsCard = (entity: CardEntity): entity is FullVideoGoodsCardEntity => {
  return entity.type === 'FULL_VIDEO_GOODS_CARD';
};

export type CardEntity =
  | GoodsCardEntity
  | PrimaryCardEntity
  | VideoGoodsCardEntity
  | FullVideoGoodsCardEntity;
